// provide default keys and values

const componentTypes = {
    "IMAGE": "IMAGE",
    "LINE": "LINE",
    "FREE_TEXT": "FREE_TEXT",
    "BARCODE": "BARCODE",
    "QR_CODE": "QR_CODE",
    "RECEIPT_SUMMARY": "RECEIPT_SUMMARY",
    "ONLINE_ORDER_VENDOR_ID": "ONLINE_ORDER_VENDOR_ID",
    "ONLINE_ORDER_CUSTOMER_INFO": "ONLINE_ORDER_CUSTOMER_INFO",
    "ONLINE_ORDER_INSTRUCTIONS": "ONLINE_ORDER_INSTRUCTIONS",
    "TOTAL": "TOTAL",
    "AGGREGATOR_NOTE": "AGGREGATOR_NOTE",
    "KOT_ITEMS": "KOT_ITEMS",
    "VOID_ITEMS": "VOID_ITEMS",
    "FOOD_READY_ITEMS": "FOOD_READY_ITEMS"
};

const _defaultValues = {
    TABLE_NO: "A1",
    BILL_NO: "20220001",
    TOKEN_NO: "15",
    DATE: "31-Oct-2022",
    TIME: "23:35",
    RECEIPT_EMPLOYEE: "PoS Admin",
    PAX_COUNT: "4",
    SERVICE_TYPE: "Table",
    RECEIPT_COMMENT: "``comment comes here``",
    RECEIPT_KOT_NUMBERS: "101, 107",
    RECEIPT_SUMMARY_ITEMS: `----------------------------------------
ITEM                         QTY     AMT
----------------------------------------
Diet Coke                     1   175.00
Egg Biryani                   1   249.00
----------------------------------------
Sub Total                     2   424.00
Service Charge                     21.20
Service Charge                      8.48
`,
    TAX_SUMMARY_NO_HEADER: `SGST                       2.5%   175.00
CGST                       2.5%   249.00`,
    TAX_SUMMARY: `TAX SUMMARY
TAX                        RATE     AMT
----------------------------------------
SGST                       2.5%   175.00
CGST                       2.5%   249.00`,
    TAX_SUMMARY_1: `----------------------------------------
Total Tax                           0.00`,
    RECEIPT_SUMMARY_INFO: `
Round off                           0.32
----------------------------------------`,
    TOTAL: "454.00",
    KOT_NUMBER: "101",
    KOT_LINE_NAME: "Chef Mode",
    PLACED_BY_EMPLOYEE: "PoS Admin",
    KOT_EMPLOYEE: "PoS Admin",
    VOID_EMPLOYEE: "PoS Admin",
    VOID_REASON: "VOID - OVER COOKED",
    FOOD_READY_EMPLOYEE: "PoS Admin",
    ONLINE_ORDER_VENDOR_ID: "``Merchant name``: 202200001",
    ONLINE_ORDER_CUSTOMER_INFO: "\nCustomer__name\nCustomer_address_1\nCustomer_address_line_2\nPhone:Customer_phone_no",
    ONLINE_ORDER_INSTRUCTIONS: "\nInstructions goes here..",
    TAX_ID_INFO: "FSSAI: 123ASD4456D\nGSTIN: 2ABCDER34F4",
    RECEIPT_TITLE: "INVOICE",
    ADDRESS: "``LOCATION__NAME\nAddress__line_1\nAddress__line_2\nCITY,PIN\nPhone:PHONE__NUMBER``"
};


const getDefaultValue = key => {
    return _defaultValues[key] || "";
};

const getReceiptSummary = (settings) => {
    // console.log({ settings });
    let taxSummary = false;
    let separateTax = false;
    if (settings && settings.receiptSummary) {
        taxSummary = settings.receiptSummary.taxSummary;
        separateTax = settings.receiptSummary.separateTax;
    }
    let val = _defaultValues["RECEIPT_SUMMARY_ITEMS"];
    if (taxSummary) {
        val += "\n" + _defaultValues["TAX_SUMMARY"] + "\n" + _defaultValues["TAX_SUMMARY_1"];
    } else if (!separateTax) {
        val += _defaultValues["TAX_SUMMARY_1"];
    }
    if (separateTax) {
        if (taxSummary) {
            val += "\n";
        }
        val += _defaultValues["TAX_SUMMARY_NO_HEADER"];
    }
    val += _defaultValues["RECEIPT_SUMMARY_INFO"];
    return val;
};

const getKotItems = (settings) => {
    console.log(settings);
    if (settings) {
        const kotSettings = settings.kotSettings;
        if (kotSettings && kotSettings.quantityAlignment === "LEFT") {
            return "1                             Diet Coke";
        }
    }
    return "Diet Coke                             1";
};

const formatText = (label, val) => `${label}${label ? ": " : ""}${val}`;

const _formStyle = (style) => {
    return `
      dec--${style.decoration} 
      ff--${style.fontFamily} 
      fs--${style.fontSize} 
      fst--${style.fontStyle} 
      fw--${style.fontWeight} 
      justify--${style.justify} 
    `;
};

const _setPrintViewVal = (c, url) => {
    console.log({url}, "IMAGES");
    switch (c.componentType) {
        case componentTypes.IMAGE:
            c.src = `${url}/images/${c.galleryId}`;
            c.isImage = true;
            break;
        case componentTypes.BARCODE:
            c.isIcon = true;
            c.icon = "mdi-barcode";
            break;
        case componentTypes.QR_CODE:
            c.isIcon = true;
            c.icon = "mdi-qrcode";
            break;
        case componentTypes.LINE:
            c.displayText = c.text.repeat(c.style.charLen || 40);
            break;
        case componentTypes.FREE_TEXT:
            c.displayText = formatText(c.label, c.text);
            break;
        case componentTypes.AGGREGATOR_NOTE:
            c.displayText = formatText(c.label, c.text);
            break;
        case componentTypes.RECEIPT_SUMMARY:
            c.displayText = getReceiptSummary(c.settings);
            break;
        case componentTypes.ONLINE_ORDER_VENDOR_ID:
            c.displayText = getDefaultValue(c.componentType);
            break;
        case componentTypes.ONLINE_ORDER_CUSTOMER_INFO: {
            const val = getDefaultValue(c.componentType);
            c.displayText = "----------------------------------------\n" +
                formatText(c.label, val);
            break;
        }
        case componentTypes.ONLINE_ORDER_INSTRUCTIONS: {
            const val = getDefaultValue(c.componentType);
            c.displayText = "----------------------------------------\n" +
                formatText(c.label, val);
            break;
        }
        case componentTypes.TOTAL: {
            const val = getDefaultValue(c.componentType);
            const label = c.label ? c.label : "PAY";
            c.displayText = formatText(label, val);
            break;
        }
        case componentTypes.KOT_ITEMS:
        case componentTypes.VOID_ITEMS:
        case componentTypes.FOOD_READY_ITEMS:
            c.displayText = getKotItems(c.settings);
            break;

        default: {
            // console.log(c.componentType);
            const val = getDefaultValue(c.componentType);
            c.displayText = formatText(c.label, val);
            break;
        }
    }
};

const formTemplate = (templateLines, url) => {
    templateLines.forEach((tl) => {
        tl.components &&
            tl.components.forEach((c) => {
                c.css = _formStyle(c.style);
                _setPrintViewVal(c, url);
            });
    });
    return templateLines;
};

const defaultStyle = () => {
    return {
        charLen: 40,
        decoration: "normal",
        fontFamily: "a",
        fontSize: "normal",
        fontStyle: "normal",
        fontWeight: "normal",
        justify: "ct"
    };
};

const componentSettings = {};
componentSettings[componentTypes.RECEIPT_SUMMARY] = { key: "receiptSummary", compId: "receipt-summary" };
componentSettings[componentTypes.KOT_ITEMS] = { key: "kotSettings", compId: "kot-settings" };
componentSettings[componentTypes.VOID_ITEMS] = { key: "kotSettings", compId: "kot-settings" };
componentSettings[componentTypes.FOOD_READY_ITEMS] = { key: "kotSettings", compId: "kot-settings" };
const getCompSettings = (componentType) => {
    return componentSettings[componentType];
};

const newComponent = () => {
    return {
        refId: _generateTmpRef(),
        componentType: "FREE_TEXT",
        label: "",
        text: "",
        style: defaultStyle()
    };
};

const newLine = () => {
    return {
        refId: _generateTmpRef(),
        number: null,
        components: [newComponent()]
    };
};

const initTemplate = (template) => {
    // console.log({ template });
    template.templateLines.forEach(tl => {
        tl.refId = _generateTmpRef();
        tl.components.forEach(c => {
            c.refId = _generateTmpRef();
        });
    });
    return template;
};

const _generateTmpRef = () => Math.random().toString(36);

const masterIns = () => {
    return {
        "paperCuts": [],
        "decoration": [],
        "fontFamily": [],
        "fontSize": [],
        "fontStyle": [],
        "fontWeight": [],
        "justifies": [],
        "components": []
    };
};

const checkEnabledSettings = (componentType) => {
    return [
        componentTypes.RECEIPT_SUMMARY,
        componentTypes.KOT_ITEMS,
        componentTypes.VOID_ITEMS,
        componentTypes.FOOD_READY_ITEMS
    ].includes(componentType);
};

export {
    componentTypes,
    getDefaultValue,
    formTemplate,
    formatText,
    newComponent,
    newLine,
    initTemplate,
    masterIns,
    checkEnabledSettings,
    getCompSettings
};